import { refreshPlayerMe, refreshKycStatus } from '~/utils/applyPlayerMe'

/**
 * 持久化登录恢复后补拉余额、档案与 KYC 状态（登录成功路径由 useAuth 负责）。
 */
export default defineNuxtPlugin(() => {
  const userStore = useUserStore()
  if (!userStore.isLoggedIn) return

  const { refreshWallet } = useWallet()

  refreshWallet().catch(error => {
    console.error('[wallet] refreshWallet on restore failed:', error)
  })

  refreshPlayerMe().catch(error => {
    console.error('[auth] fetchMe on restore failed:', error)
  })

  // 进入应用就拉一次 KYC 认证状态与资料（功能开关 kyc_required 已由上面的 /me 回填）
  refreshKycStatus().catch(error => {
    console.error('[kyc] fetchKycStatus on restore failed:', error)
  })
})
